﻿import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { BookDemoContext } from './components/BookDemoContext'
import BookDemoModal from './components/BookDemoModal'
import HomePage from './pages/HomePage'
import ProductTour from './pages/ProductTour'
import HowItWorks from './pages/HowItWorks'

function AppRedirect() {
  const location = useLocation()
  const appUrl = import.meta.env.VITE_SMARTHIRE_APP_URL || 'http://localhost:3000'
  window.location.replace(`${appUrl}${location.pathname}${location.search}`)
  return null
}

export default function App() {
  const [showDemo, setShowDemo] = useState(false)
  const [demoSource, setDemoSource] = useState('')
  const openDemo = (source = 'Book a Demo') => { setDemoSource(source); setShowDemo(true) }
  return (
    <BookDemoContext.Provider value={openDemo}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product-tour" element={<ProductTour />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="*" element={<AppRedirect />} />
        </Routes>
      </BrowserRouter>
      {showDemo && <BookDemoModal source={demoSource} onClose={() => setShowDemo(false)} />}
    </BookDemoContext.Provider>
  )
}
